<template>
  <div class="login-container">
    <div class="login-box">
      <!-- 系统标题 -->
      <div class="login-header">
        <h1 class="system-name">🏪 收银系统</h1>
        <p class="system-desc">专业零售收银管理解决方案</p>
      </div>

      <!-- 登录表单 -->
      <div class="login-form">
        <form @submit.prevent="handleLogin">
          <div class="form-item">
            <label class="form-label">用户名</label>
            <input
              v-model="loginForm.username"
              type="text"
              class="form-input"
              placeholder="请输入收银员用户名"
              autocomplete="username"
            />
          </div>

          <div class="form-item">
            <label class="form-label">密码</label>
            <input
              v-model="loginForm.password"
              type="password"
              class="form-input"
              placeholder="请输入密码"
              autocomplete="current-password"
            />
          </div>

  
          <div class="form-actions">
            <button
              type="submit"
              class="login-button"
              :disabled="loading"
            >
              {{ loading ? '登录中...' : '登录系统' }}
            </button>
          </div>
        </form>
      </div>

      <!-- 系统信息 -->
      <div class="system-info">
        <p>版本：v1.0.0</p>
        <p>© 2024 收银系统</p>
      </div>
    </div>
  </div>
</template>

<script>
import { cashierApi } from '../api/cashier.js'

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      loginForm: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    async handleLogin() {
      // 验证表单
      if (!this.loginForm.username) {
        alert('请输入用户名')
        return
      }

      if (!this.loginForm.password) {
        alert('请输入密码')
        return
      }

      this.loading = true

      try {
        // 调用收银系统登录API
        const result = await cashierApi.login({
          username: this.loginForm.username,
          password: this.loginForm.password
        })

        if (result.success && result.data) {
          const { token, cashier_info, shop_info } = result.data

          // 保存token到localStorage
          localStorage.setItem('token', token)

          // 保存登录状态和用户信息
          localStorage.setItem('isLoggedIn', 'true')
          localStorage.setItem('username', cashier_info.username)
          localStorage.setItem('nickname', cashier_info.nickname)
          localStorage.setItem('shopId', cashier_info.shop_id)
          localStorage.setItem('shopName', shop_info.name)

          // 登录成功
          alert(`登录成功！欢迎 ${cashier_info.nickname}`)

          // 跳转到主页，传递完整用户信息
          this.$emit('login-success', {
            token,
            cashier_info,
            shop_info,
            loginTime: new Date().toISOString()
          })

        } else {
          // 登录失败，直接使用返回的错误信息
          const errorMessage = result.message || '登录失败'
          alert(errorMessage)
        }

      } catch (error) {
        console.error('登录错误:', error)

        // 处理网络错误等异常情况
        let errorMessage = '登录失败，请检查网络连接'

        if (error.message.includes('HTTP Error:')) {
          errorMessage = '网络请求失败，请稍后重试'
        } else if (error.message === 'Request timeout') {
          errorMessage = '请求超时，请检查网络连接'
        } else if (error.message === 'Failed to fetch') {
          errorMessage = '网络连接失败，请检查网络设置'
        } else if (error.message) {
          errorMessage = error.message
        }

        alert(errorMessage)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    // 检查是否已登录（通过token）
    const token = localStorage.getItem('token')
    if (token) {
      // 如果有token，直接触发登录成功事件
      const cashier_info = {
        username: localStorage.getItem('username'),
        nickname: localStorage.getItem('nickname'),
        shop_id: parseInt(localStorage.getItem('shopId'))
      }
      const shop_info = {
        name: localStorage.getItem('shopName'),
        id: parseInt(localStorage.getItem('shopId'))
      }

      this.$emit('login-success', {
        token,
        cashier_info,
        shop_info,
        loginTime: new Date().toISOString()
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Microsoft YaHei', sans-serif;
}

.login-box {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  width: 400px;
  max-width: 90%;
  animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.system-name {
  font-size: 32px;
  font-weight: bold;
  color: #1890ff;
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.system-desc {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.login-form {
  margin-bottom: 30px;
}

.form-item {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-input {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #4096ff;
  box-shadow: 0 0 0 2px rgba(64, 150, 255, 0.2);
}

.form-input:hover {
  border-color: #4096ff;
}

.form-actions {
  margin-top: 32px;
}

.login-button {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.login-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #4096ff 0%, #1890ff 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.system-info {
  text-align: center;
  color: #999;
  font-size: 12px;
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;
}

.system-info p {
  margin: 4px 0;
}
</style>